import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Plan Products", -1)
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Included products", -1)
const _hoisted_7 = { class: "flex flex-col gap-1" }
const _hoisted_8 = { class: "w-40 border-b border-gray-400" }
const _hoisted_9 = { class: "flex gap-1 flex-col text-xs px-2" }
const _hoisted_10 = { class: "ml-auto" }
const _hoisted_11 = { class: "flex gap-2 items-center" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_13 = { class: "max-w-sm" }
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_16 = { class: "flex flex-col cursor-default w-44 border-b border-gray-400" }
const _hoisted_17 = { class: "text-dark-blue-500 opacity-75 text-xs" }
const _hoisted_18 = { class: "flex flex-wrap w-full" }
const _hoisted_19 = { class: "ml-auto flex gap-2 items-start" }
const _hoisted_20 = { class: "flex flex-col gap-1" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs mr-2" }, "Qty", -1)
const _hoisted_23 = { class: "text-xs text-right" }
const _hoisted_24 = { class: "text-xs text-right" }
const _hoisted_25 = {
  key: 0,
  class: "h-4 w-4"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Add product", -1)
const _hoisted_29 = { class: "max-h-36 overflow-y-auto scrollbar overflow-x-hidden min-w-50 max-w-xs overflow-hidden w-48 flex flex-col gap-1 shadow-xl" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "text-left" }

import {
	UiRadioTabs,
	UiLine,
	Tooltip,
	SvgIcon,
	UiCard,
	UiButton
} from '@/ui-kit';
import { computed, ref } from 'vue';
import { useUSPSExtraServices } from '@/inbox/compose-input/use-usps-price';
import {
	AvailablePlanItem,
	useBilling
} from '../composition';
import { toCurrency, uuid } from '@/utils';
import QuantityItem from '../components/QuantityItem.vue';
import { Dropdown } from 'floating-vue';
import { StripeSubscriptionItem } from '../composition/subscription-v2-state';
import { useBillingUsages } from '../composition/use-billing-usages';
import PlanUpdateDialog from '../components/PlanUpdateDialog.vue';
import { useToggle } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionProducts',
  setup(__props) {

const isIncludedExpanded = ref(false);

const planUpdateDialogRef =
	ref<InstanceType<typeof PlanUpdateDialog>>();
const { getPricesList } = useUSPSExtraServices();
const {
	getPlanPriceDescription,
	editableBillingItems,
	getSubItemTotal,
	availablePlans,
	currentSubItems,
	getProductDetails,
	hasSavedItem,
	currentSubscription,
	purchasePlan,
	selectedPeriod,
	setSelectedPeriod
} = useBilling();
const usages = useBillingUsages();

const includedProducts = [
	{
		title: 'Contacts Management',
		features: [
			'Unlimited contacts',
			'Unlimited custom contact attributes'
		],
		payment: 'Free',
		paymentDetails: null
	},
	{
		title: 'Email System',
		features: [
			'Unlimited emails',
			'Unlimited email addresses',
			'Custom email domains'
		],
		payment: 'Free',
		paymentDetails: null
	},
	{
		title: 'Physical Mail',
		features: ['Unlimited physical mail addresses'],
		payment: 'Pay As You Go',
		paymentDetails: getPricesList()
	}
];

const totalPrice = computed(() => {
	return editableBillingItems.value
		.reduce(
			(acc, curr) => acc + getSubItemTotal(curr),
			0
		)
		.toFixed(2)
		.padEnd(2, '.00');
});

const productsToAdd = computed(() => {
	let result: AvailablePlanItem[] = [];

	Object.values(availablePlans.value)
		.slice()
		.forEach((item) => {
			result = [
				...result,
				...item[selectedPeriod.value]
			];
		});

	result = result
		.slice()
		.filter(
			(item) =>
				!editableBillingItems.value.some(
					(addedItem) =>
						addedItem.stripe_product ===
						item.stripe_product_id
				)
		);

	return result;
});

function addProduct(plan: AvailablePlanItem) {
	editableBillingItems.value = [
		...editableBillingItems.value,
		{
			id: Math.random(),
			stripe_id: uuid(5),
			stripe_product: plan.stripe_product_id,
			stripe_price: plan.stripe_price_id,
			quantity: 1,
			created_at: Date.now().toString(),
			updated_at: Date.now().toString(),
			price: plan.stripe_price,
			interval: plan.interval,
			friendlyName: plan.stripe_product_name,
			subscriptionName: plan.subscription_name,
			productAlias: plan.stripe_product_id
		}
	];
}

async function removeProduct(plan: StripeSubscriptionItem) {
	if (
		!hasSavedItem(plan.stripe_price) ||
		(await usages.canRemoveProduct(
			plan.subscriptionName,
			plan.stripe_product
		))
	) {
		editableBillingItems.value =
			editableBillingItems.value.filter((item) => {
				return (
					item.stripe_product !==
					plan.stripe_product
				);
			});
	}
}

const noSubscriptionChanges = computed(() => {
	return (
		editableBillingItems.value.length ===
			currentSubItems.value.length &&
		currentSubItems.value.every(
			(item) =>
				editableBillingItems.value.find(
					(editableItem) =>
						item.stripe_product ===
						editableItem.stripe_product
				)?.quantity === item.quantity
		)
	);
});

async function updateQuantity(
	value: number,
	product: StripeSubscriptionItem
) {
	if (
		product.quantity < value ||
		!hasSavedItem(product.stripe_price) ||
		(await usages.canDecreaseProduct(product))
	) {
		product.quantity = value;
	}
}

const [loading, setIsLoading] = useToggle();

async function saveSubscriptionChanges() {
	if (currentSubscription.value) {
		return planUpdateDialogRef.value?.openDialog();
	}

	setIsLoading(true);
	await purchasePlan(
		'Subscription',
		editableBillingItems.value.map((item) => ({
			price: item.stripe_price,
			quantity: item.quantity
		}))
	);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", {
            class: _normalizeClass(["text-xs text-green-600 opacity-0 transition", {
						'opacity-100':
							!_unref(noSubscriptionChanges) &&
							_unref(currentSubscription)
					}])
          }, " Your subscription is changed. Save subscription changes. ", 2)
        ]),
        _createVNode(_unref(UiButton), {
          disabled: _unref(noSubscriptionChanges),
          loading: _unref(loading),
          class: "!h-10 !text-sm",
          theme: "primary",
          onClick: saveSubscriptionChanges
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(currentSubscription)
						? 'Save Subscription Changes'
						: 'Go to checkout'), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _createVNode(_unref(UiCard), { theme: "white" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "cursor-pointer flex items-center gap-2 hover:bg-dark-blue-400 hover:bg-opacity-15",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
						isIncludedExpanded.value =
							!isIncludedExpanded.value
					))
            }, [
              _hoisted_6,
              _createVNode(_unref(SvgIcon), {
                class: _normalizeClass(["transition h-4 w-4 transform rotate-90", 
							isIncludedExpanded.value
								? '-rotate-90'
								: 'rotate-90'
						]),
                name: "arrow"
              }, null, 8, ["class"])
            ]),
            (isIncludedExpanded.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(includedProducts, (product, i) => {
                  return _createElementVNode("div", {
                    class: "mx-2 p-2 rounded-md bg-gray-200 shadow-md flex gap-8 text-sm items-center max-w-xl",
                    key: i
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(product.title), 1),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.features, (feature) => {
                          return (_openBlock(), _createElementBlock("span", { key: feature }, " • " + _toDisplayString(feature), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_unref(Tooltip), {
                        disabled: 
									!product.paymentDetails
								
                      }, {
                        popper: _withCtx(() => [
                          (
											product.paymentDetails
										)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.paymentDetails, (item, j) => {
                                  return (_openBlock(), _createElementBlock("div", { key: j }, " • " + _toDisplayString(item.title) + " - " + _toDisplayString(item.price), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("button", _hoisted_11, [
                            _createTextVNode(_toDisplayString(product.payment) + " ", 1),
                            (
											product.paymentDetails
										)
                              ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                                  key: 0,
                                  name: "info",
                                  class: "h-3 w-3"
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["disabled"])
                    ])
                  ])
                }), 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              (!_unref(currentSubscription))
                ? (_openBlock(), _createBlock(_unref(UiRadioTabs), {
                    key: 0,
                    class: "!mb-0",
                    noValidate: true,
                    label: "Subscribe period",
                    "model-value": _unref(selectedPeriod),
                    options: [
							{
								title: 'Monthly',
								value: 'monthly'
							},
							{
								title: 'Yearly',
								value: 'yearly'
							}
						],
                    name: "tab",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
							_unref(setSelectedPeriod)($event)
						))
                  }, null, 8, ["model-value"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" Purchased products: Total "),
              _createElementVNode("span", _hoisted_14, "$" + _toDisplayString(_unref(totalPrice)), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableBillingItems), (product) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "mx-2 p-2 rounded-md bg-gray-200 shadow-md flex gap-8 text-sm group max-w-xl",
                key: product.stripe_price
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(product.friendlyName), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(getProductDetails)(
										product
									)?.price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getProductDetails)(
									product
								)?.features || [], (detail, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "px-2 text-xs w-1/2",
                        key: i
                      }, " • " + _toDisplayString(detail), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(QuantityItem, {
                        "onUpdate:modelValue": ($event: any) => (
										updateQuantity(
											$event,
											product
										)
									),
                        modelValue: 
										product.quantity
									,
                        loading: false
                      }, null, 8, ["onUpdate:modelValue", "modelValue"])
                    ]),
                    _createElementVNode("span", _hoisted_23, "Usage: " + _toDisplayString(_unref(usages).getProductUsages(
										product
									)) + " / " + _toDisplayString(product.quantity), 1),
                    _createElementVNode("span", _hoisted_24, " Total: " + _toDisplayString(_unref(toCurrency)(
										_unref(getSubItemTotal)(
											product
										)
									)), 1)
                  ]),
                  (
								product.subscriptionName ===
								'team-seats'
							)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                    : (_openBlock(), _createBlock(_unref(Tooltip), {
                        key: 1,
                        class: "flex items-center mt-1"
                      }, {
                        popper: _withCtx(() => [
                          _createTextVNode(" Remove product ")
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (
									removeProduct(product)
								),
                            class: "opacity-0 transition group-hover:opacity-100 text-red-400 select-none outline-none"
                          }, [
                            _createVNode(_unref(SvgIcon), {
                              class: "h-4 w-4",
                              name: "only-close"
                            })
                          ], 8, _hoisted_26)
                        ]),
                        _: 2
                      }, 1024))
                ])
              ]))
            }), 128)),
            (_unref(productsToAdd).length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_unref(UiLine), { class: "!mt-1 !mb-1" }),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_unref(Dropdown), {
                      dropdownPlacement: "left-start",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
                    }, {
                      popper: _withCtx(({ hide }) => [
                        _createElementVNode("div", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productsToAdd), (product) => {
                            return (_openBlock(), _createElementBlock("button", {
                              onClick: ($event: any) => {
											hide();
											addProduct(
												product
											);
										},
                              class: "px-2 py-0.5 transition flex flex-col hover:bg-dark-blue-400 hover:bg-opacity-15",
                              key: 
											product.stripe_price_id
										
                            }, [
                              _createElementVNode("span", null, _toDisplayString(product.stripe_product_name), 1),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(getPlanPriceDescription)(
													product
												)), 1)
                            ], 8, _hoisted_30))
                          }), 128))
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(UiButton), {
                          class: "!h-10 !text-sm",
                          theme: "primary-outlined"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SvgIcon), {
                              name: "only-plus",
                              class: "mr-2"
                            }),
                            _hoisted_28
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(PlanUpdateDialog, {
      ref_key: "planUpdateDialogRef",
      ref: planUpdateDialogRef
    }, null, 512)
  ], 64))
}
}

})